<template>
  <tr>
    <td>
      <template v-if="simcard.Car">
        <img style="max-height: 50px; max-width: 75px;" :src="carImage"/>
        <br/>
        <router-link :to="`/fleet/vehicles/${simcard.Car.uuid}`">
          {{ simcard.Car.dropdownLabel }}
        </router-link>
      </template>
      <template v-if="simcard.NPort">
        NPort located at <br><strong>{{ simcard.NPort.location }}</strong><br>
        <strong>IP:</strong> {{ simcard.NPort.ipAddress }}<br>
        <strong>Port:</strong> {{ simcard.NPort.port }}<br>
        <strong>Main Port?:</strong> {{ simcard.NPort.mainNPort ? 'Yes' : 'No' }}
      </template>
    </td>
    <td>
      {{ simcard.number }}
    </td>
    <td>
      {{ simcard.serialNumber }}
    </td>
    <td>
      {{ simcard.provider }}
    </td>
    <td>
      {{ simcard.puk }}
    </td>
    <td>
      {{ simcard.planType }}
    </td>
    <td>
      <router-link class="btn btn-sm btn-primary" :to="'/hardware/sim-cards/edit/' + simcard.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </td>
  </tr>
</template>

<script>

export default {
  components: {
  },
  name: 'SimCardRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    carImage () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      this.simcard.Car.CarType.AmazonImage.objectKey
    },
    simcard () {
      return {
        Car: {
          CarType: {
            AmazonImage: {
              objectKey: 'spacer.gif'
            }
          }
        },
        ...this.object,
        ...this.updatedSimcard
      }
    }
  },
  data () {
    return {
      updatedSimcard: {}
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/SimCard.vue